import React from "react";
import { connect } from "react-redux";
import { List, Button, Select, Icon } from "antd";
import Preloader from "../../Preloader/Preloader";
import UpdateUserWrapper from "./UpdateUser.style";
import {
  fetchAllUsers,
  changeUserData,
  updateExistingUser,
  updateNewUserRole,
  setCurrentListPage,
  resetEditUserData,
  setSearchText,
  setSearchResults,
} from "../../../redux/actions/Users/UsersActions";

const Option = Select.Option;

class UpdateUser extends React.Component {
  constructor() {
    super();

    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.renderEditRole = this.renderEditRole.bind(this);
    this.renderEditStatus = this.renderEditStatus.bind(this);
    this.handleActiveChange = this.handleActiveChange.bind(this);
    this.handleActivateEdit = this.handleActivateEdit.bind(this);
    this.renderSaveOptions = this.renderSaveOptions.bind(this);
    this.handleCancelSave = this.handleCancelSave.bind(this);
  }

  handleRoleChange(value) {
    this.props.updateNewUserRole(value);
  }

  handleSubmitSave(email, key) {
    console.log(email);
    let _editData = this.props.USERSREDUCER.all_users.filter(
      (user) => user.email === email
    )[0];
    _editData["role"] = this.props.USERSREDUCER.update_user.new_user_role;
    this.props.updateExistingUser(_editData);
  }

  handleCancelSave() {
    this.props.resetEditUserData();
  }

  handleActiveChange(key) {
    let _editData = this.props.USERSREDUCER.all_users[key - 1];
    _editData["active"] = !_editData["active"];
    this.props.updateExistingUser(_editData);
  }

  handleActivateEdit(key) {
    this.props.changeUserData(key);
    this.props.updateNewUserRole(
      this.props.USERSREDUCER.all_users[key - 1]["role"]
    );
  }

  renderEditRole(curr_role, key) {
    return this.props.USERSREDUCER.update_user.isEdit &&
      this.props.USERSREDUCER.update_user.update_user_key === key ? (
      <div className="update-user-role">
        <Select
          defaultValue={curr_role}
          style={{ width: 120 }}
          onChange={this.handleRoleChange}
        >
          <Option value="ADMIN">ADMIN</Option>
          <Option value="NONADMIN">NON-ADMIN</Option>
          <Option value="SALES">SALES</Option>
        </Select>
      </div>
    ) : (
      <p className="update-user-role">{curr_role}</p>
    );
  }

  renderEditStatus(curr_status, key) {
    return this.props.USERSREDUCER.update_user.isEdit &&
      this.props.USERSREDUCER.update_user.update_user_key === key ? (
      <Button
        className="toggle-user-btn"
        type="primary"
        onClick={() => this.handleActiveChange(key)}
      >
        {curr_status === true ? "DE-ACTIVATE" : "ACTIVATE"}
      </Button>
    ) : (
      <p className="toggle-user-text">{curr_status ? "ACTIVE" : "IN-ACTIVE"}</p>
    );
  }

  renderSaveOptions(email, key) {
    return this.props.USERSREDUCER.update_user.isEdit &&
      this.props.USERSREDUCER.update_user.update_user_key === key ? (
      <div className="flex edit-enabled-options">
        <Icon type="check" onClick={() => this.handleSubmitSave(email, key)} />
        <Icon type="close" onClick={this.handleCancelSave} />
      </div>
    ) : (
      <Icon
        type="edit"
        className="activate-edit-user"
        onClick={() => this.handleActivateEdit(key)}
      />
    );
  }

  handleUserSearch(e) {
    const search_keyword = e.target.value.toLowerCase();
    let filtered_users = this.props.USERSREDUCER.all_users.filter((user) =>
      user.email.toLowerCase().includes(search_keyword)
    );
    this.props.setSearchText(search_keyword);
    this.props.setSearchResults(filtered_users);
  }

  componentDidMount() {
    this.props.fetchAllUsers();
  }

  render() {
    let _userList = this.props.USERSREDUCER.all_users;

    let search_results = this.props.USERSREDUCER.search.results;
    let search_text = this.props.USERSREDUCER.search.text;

    let data_source =
      search_text.length > 0 || search_results.length > 0
        ? search_results
        : _userList;

    if (this.props.USERSREDUCER.all_users.length === undefined) {
      return <Preloader />;
    } else {
      return (
        <UpdateUserWrapper>
          <input
            type="text"
            placeholder="Search for users by email here..."
            className="search-user-input"
            onChange={(e) => this.handleUserSearch(e)}
          />
          <List
            header={
              <div className="flex header-user-wrapper">
                <p className="user-name">Name</p>
                <p className="user-email-id">Email ID</p>
                <p className="user-status">Status</p>
                <p className="user-role">Role</p>
              </div>
            }
            dataSource={data_source}
            renderItem={(user, i) => (
              <List.Item key={i + 1}>
                <div className="flex user-wrapper">
                  <p className="user-name">{user.name}</p>
                  <p className="user-email-id">{user.email}</p>
                  <div className="toggle-user-status">
                    {this.renderEditStatus(user.active, i + 1)}
                  </div>
                  {this.renderEditRole(user.role, i + 1)}
                  {this.renderSaveOptions(user.email, i + 1)}
                </div>
              </List.Item>
            )}
            pagination={false}
          />
        </UpdateUserWrapper>
      );
    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  fetchAllUsers,
  changeUserData,
  updateNewUserRole,
  setCurrentListPage,
  updateExistingUser,
  resetEditUserData,
  setSearchText,
  setSearchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUser);



// WEBPACK FOOTER //
// ./src/components/Users/UpdateUser/UpdateUser.js